<template>
  <div class="container">
    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />
    <div class="container-fluid h-custom">
      <div style="display: flex; justify-content: space-between; background-color: #f0f0f0; padding: 10px; border-radius: 5px;">
        <h4 style="margin: 0; font-weight: bold; color:darkblue;">Olvidó su contraseña?</h4>
      </div>
      <hr>
      <div>
        <div>
          <br>
          <h5>Ingrese su dirección de correo electrónico, recibirá un mensaje para la recuperación de su contraseña.</h5>
          <br>
        </div>
      </div>
      <div class="d-flex" style="gap: 20px;">
        <div class="flex-grow-1">
          <img src="../../assets/images/olvido_clave.png" class="img-fluid" alt="Sample image">
        </div>
        <div class="flex-grow-1 border-rounded" style="background-color: beige; padding: 50px;">
          <form id="reset-form">
            <!-- Email input -->
            <div class="form-outline mb-4">
              <input type="email" id="email" class="form-control form-control-lg"
                placeholder="Ingrese la dirección de correo registrada." v-model="datosCorreo.recipient" />
              <label class="form-label" for="email">Dirección de correo</label>
            </div>
            <div class="text-center text-lg-start mt-4 pt-2">
              <button type="button" class="btn btn-primary btn-lg"
                style="padding-left: 2.5rem; padding-right: 2.5rem;" @click="resetear()">Resetear clave</button>
<!--
              <p class="small fw-bold mt-2 pt-1 mb-0">No tiene una cuenta?
                <router-link to="/" class="link-danger">Regístrese</router-link>
              </p>
-->
            </div>
            <br>
            <br>
            <p class="mensaje">{{ mensaje }}</p>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import swal2 from 'sweetalert2';

export default {
  data() {
    return {
      datosCorreo: {},
      mensaje: ''
    }
  },
  mounted() {
    const form = document.getElementById('reset-form');
    form.addEventListener('keydown', this.handleEnterSubmit);
  },
  beforeUnmount() {
    const form = document.getElementById('reset-form');
    form.removeEventListener('keydown', this.handleEnterSubmit);
  },
  methods: {
    handleEnterSubmit(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.resetear();
      }
    },
    validateEmail(p_email) {
      if (p_email === "") {
        return "Por favor ingrese su dirección de correo en el formato indicado.";
      }
      // eslint-disable-next-line
      if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(p_email)) {
        return "";
      }
      else {
        return "Dirección de correo electrónico inválida.";
      }
    },
    async resetear() {
      try {
        const response = await api.post(`/resetear-clave/${this.datosCorreo.recipient}`);
        
        if (response.status === 200) {
          swal2.fire({
            title: '¡Éxito!',
            text: response.data, // Mensaje de éxito desde el servidor
            icon: 'success',
            confirmButtonText: 'Aceptar'
          });
          this.$router.push('/Login');
        } else {
          swal2.fire({
            title: 'Error',
            text: 'Error: ' + response.data, // Mensaje de error desde el servidor
            icon: 'error',
            confirmButtonText: 'Aceptar'
          });
        }
      } catch (error) {
        if (error.response) {
          swal2.fire({
            title: 'Error',
            text: 'Error: ' + error.response.data, // Mensaje de error devuelto por el servidor
            icon: 'error',
            confirmButtonText: 'Aceptar'
          });
        } else {
          swal2.fire({
            title: 'Error',
            text: 'Error al intentar comunicarse con el servidor.',
            icon: 'error',
            confirmButtonText: 'Aceptar'
          });
        }
      }
    }

  }
}
</script>

<style scoped>
.divider:after,
.divider:before {
  content: "";
  flex: 1;
  height: 1px;
  background: #eee;
}

.h-custom {
  height: calc(100% - 73px);
}

@media (max-width: 450px) {
  .h-custom {
    height: 100%;
  }
}

.mensaje {
  color: red;
  font-family: verdana;
  font-size: 12px;
  width: 100%;
}

.border-rounded {
  border-radius: 20px;
}
</style>